import { useEffect, useState } from "react";
import Layout from "@/components/Layout";
import api from "@/lib/api";
import { MapPin, DollarSign, TrendingDown, Database } from "lucide-react";

export default function AdminGeocache() {
  const [stats, setStats] = useState(null);
  const [rows, setRows] = useState([]);

  useEffect(() => {
    api.get("/geocode/cache/stats").then((r) => setStats(r.data));
    api.get("/geocode/cache?limit=200").then((r) => setRows(r.data));
  }, []);

  return (
    <Layout>
      <div className="mb-8">
        <div className="font-mono-tech text-xs text-yellow-300 uppercase tracking-widest mb-2">/ Optimización</div>
        <h1 className="font-display font-black text-4xl md:text-5xl tracking-tighter">Cache de Geocoding</h1>
        <p className="text-zinc-400 mt-3 max-w-2xl">
          Cada dirección se consulta una vez a Google. Todas las siguientes se resuelven desde nuestra base de datos, sin costo.
        </p>
      </div>

      {stats && (
        <div className="grid md:grid-cols-4 gap-4 mb-8">
          <div className="bg-zinc-900 border border-white/10 p-6" data-testid="stat-addresses">
            <div className="flex items-center justify-between mb-4">
              <Database className="w-5 h-5 text-yellow-300" />
              <span className="font-mono-tech text-[10px] uppercase tracking-widest text-zinc-500">Direcciones</span>
            </div>
            <div className="font-display font-black text-5xl tracking-tighter">{stats.total_addresses}</div>
            <div className="font-mono-tech text-xs text-zinc-500 mt-2">Únicas en cache</div>
          </div>
          <div className="bg-zinc-900 border border-white/10 p-6" data-testid="stat-hits">
            <div className="flex items-center justify-between mb-4">
              <MapPin className="w-5 h-5 text-yellow-300" />
              <span className="font-mono-tech text-[10px] uppercase tracking-widest text-zinc-500">Consultas</span>
            </div>
            <div className="font-display font-black text-5xl tracking-tighter">{stats.total_hits}</div>
            <div className="font-mono-tech text-xs text-zinc-500 mt-2">Total resueltas</div>
          </div>
          <div className="bg-zinc-900 border border-white/10 p-6" data-testid="stat-avoided">
            <div className="flex items-center justify-between mb-4">
              <TrendingDown className="w-5 h-5 text-emerald-300" />
              <span className="font-mono-tech text-[10px] uppercase tracking-widest text-zinc-500">Google evitados</span>
            </div>
            <div className="font-display font-black text-5xl tracking-tighter text-emerald-300">{stats.google_calls_avoided}</div>
            <div className="font-mono-tech text-xs text-zinc-500 mt-2">Llamadas ahorradas</div>
          </div>
          <div className="bg-zinc-900 border border-white/10 p-6" data-testid="stat-saved">
            <div className="flex items-center justify-between mb-4">
              <DollarSign className="w-5 h-5 text-emerald-300" />
              <span className="font-mono-tech text-[10px] uppercase tracking-widest text-zinc-500">Ahorrado</span>
            </div>
            <div className="font-display font-black text-5xl tracking-tighter text-emerald-300">${stats.estimated_saved_usd}</div>
            <div className="font-mono-tech text-xs text-zinc-500 mt-2">USD estimados</div>
          </div>
        </div>
      )}

      <div className="border border-white/10 overflow-x-auto">
        <div className="p-4 border-b border-white/10 font-mono-tech text-xs text-zinc-500 uppercase tracking-widest">/ Direcciones cacheadas</div>
        <table className="w-full min-w-[720px]">
          <thead className="bg-zinc-900">
            <tr className="text-left text-[10px] font-mono-tech uppercase tracking-widest text-zinc-500">
              <th className="px-4 py-3">Dirección</th>
              <th className="px-4 py-3">Comuna</th>
              <th className="px-4 py-3">Formatted (Google)</th>
              <th className="px-4 py-3">Lat, Lng</th>
              <th className="px-4 py-3 text-right">Hits</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-white/5">
            {rows.map((r) => (
              <tr key={r.key} className="hover:bg-zinc-900/60">
                <td className="px-4 py-3 text-sm">{r.direccion}</td>
                <td className="px-4 py-3 text-sm text-zinc-400">{r.comuna}</td>
                <td className="px-4 py-3 text-xs text-zinc-500 max-w-xs truncate">{r.formatted}</td>
                <td className="px-4 py-3 font-mono-tech text-xs text-zinc-400">{r.lat?.toFixed(4)}, {r.lng?.toFixed(4)}</td>
                <td className="px-4 py-3 text-right font-mono-tech font-bold text-yellow-300">{r.hits}</td>
              </tr>
            ))}
            {rows.length === 0 && (
              <tr><td colSpan={5} className="px-4 py-10 text-center text-zinc-500 font-mono-tech text-sm">Sin registros. Las direcciones se cachean automáticamente al crear pedidos.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </Layout>
  );
}
